function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M4.12 2h15.77c.6 0 1.06.52.99 1.11l-1.8 16.22c-.04.4-.33.74-.72.85l-6.08 1.74c-.18.05-.37.05-.55 0l-6.08-1.74a1.01 1.01 0 01-.72-.85L3.13 3.11A.993.993 0 014.12 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.06 6.5a.735.735 0 00-.56-.25l-9-.02a.749.749 0 100 1.5l8.16.02-.28 2.5H8c-.41 0-.75.34-.75.75s.34.75.75.75h7.22l-.41 3.67-2.81.8-2.88-.82-.4-1.58c-.1-.4-.51-.65-.91-.55-.4.1-.65.51-.55.91l.5 2c.06.26.26.47.52.54l3.5 1a.761.761 0 00.42 0l3.5-1c.29-.08.51-.33.54-.64l1-9a.727.727 0 00-.18-.58z"
})));